
import { Component, Vue } from 'vue-property-decorator'

import { Tag } from '@/types/Tag'
import tagModule from '@/store/tag'

import ContentList from '@/components/listView/ContentList.vue'
import TagEditor from '@/components/tag/TagEditor.vue'
import { ListType } from '@/utils/enums'

@Component({
  name: 'TagList',
  components: {
    ContentList,
    TagEditor
  }
})
class TagList extends Vue {
  private listType = ListType
  private showEditor = false

  private get storeModule() {
    return tagModule
  }

  private get tags(): Tag[] {
    return tagModule.tags
  }

  private get headers() {
    return [
      { text: 'Name', value: 'name' }
    ]
  }

  private setTag(tag: Tag): void {
    tagModule.setTag(tag)
    ;(this.$refs.tagDialog as any).toggleDialog()
  }
}

export default TagList
